import { EventsStore, EventsActions } from './types';

export const defaultState: EventsStore = {
  error: null,
  isLoading: false,
  isLoaded: false,
  events: [],
};

const reducer = (
  state: EventsStore = defaultState,
  action: { type: EventsActions; payload?: any }
): EventsStore => {
  switch (action.type) {
    case EventsActions.FetchListingBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        events: [],
        error: null,
      };
    }
    case EventsActions.FetchListingError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case EventsActions.FetchListingSuccess: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: null,
        events: action.payload.events,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
